var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"wkFileInput",staticStyle:{"display":"none"},attrs:{"name":_vm.data.name,"multiple":_vm.data.multiple,"accept":_vm.data.accept,"type":"file"},on:{"change":_vm.handleChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057a7eaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewCom/WkFile/Select/main.vue
// module id = null
// module chunks = 